import Head from 'next/head';
import { GetServerSideProps } from 'next';
import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import Login from '@/components/Login';
import { LoginTone, resolveLoginTone } from '@/components/Login/tone';
import { saveLoginReturnPath } from '@/utils/loginReturnPath';

interface Props {
  tone: LoginTone;
}

const Page = ({ tone }: Props) => {
  const searchParams = useSearchParams();

  /*
   * 보호된 페이지가 /login?next=/mansion 형태로 보내면 돌아갈 경로를 담아 둡니다.
   * MS 로그인을 마치면 /redirect 가 꺼내 씁니다.
   * next 가 없으면 아무것도 담지 않아 기존처럼 루트로 갑니다.
   */
  useEffect(() => {
    saveLoginReturnPath(searchParams?.get('next'));
  }, [searchParams]);

  return (
    <>
      <Head>
        <meta
          name={'viewport'}
          content={'width=device-width, initial-scale=1'}
        />
      </Head>
      <Login tone={tone} />
    </>
  );
};

/**
 * 톤은 서버에서 정합니다 (PORTAL-13709).
 *
 * useSearchParams 로 클라이언트에서 읽으면 첫 페인트가 기본 톤으로 나갔다가
 * 뒤늦게 갈리면서 배경색이 한 번 바뀝니다. 두 톤은 배경부터 다르므로
 * 그 깜빡임이 그대로 보입니다.
 *
 * 인증을 보지 않는 페이지라 여기서 하는 일은 쿼리 한 개를 읽는 것뿐입니다.
 */
export const getServerSideProps: GetServerSideProps<Props> = async (
  context,
) => {
  const { next } = context.query;
  // 같은 키가 두 번 오면 배열이 됩니다. 그 경우는 기본 톤으로 둡니다.
  return { props: { tone: resolveLoginTone(Array.isArray(next) ? '' : next) } };
};

export default Page;
